import Vue from "vue";

// axios
import axios from "axios";

import { apiEndpoint } from "@/configs/api/api-configs";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

const {
  openErrorModal,
} = useValidationModal();

const REFRESH_API = `${apiEndpoint.bcrm_platform}/account/RefreshToken`;

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
});

const fetchBrandRef = () => {
  return (
    new URLSearchParams(window.location.search).get("brandRef") ||
    sessionStorage.getItem(window.brandSessionStorage)
  );
};

const fetchAccessToken = () => {
  let brand = JSON.parse(localStorage.getItem(window.brandLocalStorage))?.find(
    (o) => {
      return o.brandRef == fetchBrandRef();
    }
  );
  return { access_token: brand.accessToken, refresh_token: brand.refreshToken };
};

const fetchNewAccessToken = () => {
  return new Promise((resolve, reject) => {
    axiosIns
      .post(REFRESH_API, fetchAccessToken())
      .then((response) => {
        let bcrmBrands = [];
        if (localStorage.getItem(window.brandLocalStorage)) {
          bcrmBrands = [
            ...JSON.parse(
              localStorage.getItem(window.brandLocalStorage)
            )?.filter((o) => {
              return o.brandRef != fetchBrandRef();
            }),
          ];
        }
        bcrmBrands.push({
          brandRef: fetchBrandRef(),
          accessToken: response.data.data.access_token,
          refreshToken: response.data.data.refresh_token,
        });
        localStorage.setItem(
          window.brandLocalStorage,
          JSON.stringify(bcrmBrands)
        );

        resolve();
      })
      .catch((err) => {
        if (err.status == 422) {
          let brands = JSON.parse(
            localStorage.getItem(window.brandLocalStorage)
          ).filter((o) => {
            return (
              o.brandRef != sessionStorage.getItem(window.brandSessionStorage)
            );
          });

          localStorage.setItem(
            window.brandLocalStorage,
            JSON.stringify(brands)
          );
          // Reset ability
           onTokenExpireModal().then((value) => {
            return (window.location.href = "/");
          })
         
        }
        else{
          return (window.location.href = "/");
          //resolve();
        }
      });
  });
};

const onTokenExpireModal = () => {
  return new Promise((resolve, reject) => {
    openErrorModal(
      "Session Expired",
      "Please log in again.",
      null,
      () => {
        resolve();
      },
      () => {
        resolve();
      }
    );
  });
};

axiosIns.interceptors.response.use(
  (response) => response,
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url === REFRESH_API) {
      return Promise.reject(err.response);
    }

    if (err.response.status === 401 && !originalConfig.retry) {
      originalConfig.retry = true;

      await fetchNewAccessToken();
      originalConfig.headers.Authorization =
        "Bearer " + fetchAccessToken().access_token;
      return axiosIns(originalConfig);
    }

    if (err.response.status === 401 && originalConfig.retry) {
      return Promise.reject(err.response);
    }

    return Promise.reject(err);
  }
);

Vue.prototype.$http = axiosIns;
Vue.prototype.$http = useValidationModal;

export default axiosIns;


